var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.order.pay_method === 3
      ? _c("p", [
          _c(
            "span",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    content: _vm.getPrePaidData(_vm.order),
                    placement: "bottom-center",
                    classes: ["info custom-tooltip"],
                    targetClasses: ["it-has-a-tooltip custom-tooltip"],
                    offset: 10,
                    delay: {
                      show: 200,
                      hide: 700,
                    },
                  },
                  expression:
                    "{\n                content: getPrePaidData(order),\n                placement: 'bottom-center',\n                classes: ['info custom-tooltip'],\n                targetClasses: ['it-has-a-tooltip custom-tooltip'],\n                offset: 10,\n                delay: {\n                  show: 200,\n                  hide: 700\n                }\n              }",
                },
              ],
              class: {
                "badge pointer": true,
                "badge-warning": +_vm.order.price > +_vm.order.no_cash_price,
                "badge-success": !(+_vm.order.price > +_vm.order.no_cash_price),
              },
            },
            [
              _c("i", { class: { "icon-fa icon-fa-credit-card": true } }),
              _vm._v(" " + _vm._s(_vm.order.no_cash_price) + "\n          "),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.order.no_cash_price && _vm.order.pay_method !== 3
      ? _c("span", { staticClass: "badge badge-info" }, [
          _vm._v("ожидается перевод"),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }